
export const indexBannerSliderOptions = (instance, options, labels) => {
    return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        cssMode: false,
        autoplay: {
            delay: 4000,
            pauseOnMouseEnter: true
        },
        loop: false,
        autoHeight: true,
        effect: 'fade',
        pagination: {
            el: instance.paginationEl,
            clickable: true,
            hideOnClick: false,
            renderBullet: function (index, className) {
                const content = labels[index];

                return `
                    <div class="${className}">
                        <div class="swiper-bullet-content">
                            <div class="swiper-bullet-label">${content}</div>
                        </div>
                    </div>`;
            }
        },   
    }
}